import React from "react";
import "../../../css/MonthTransRental.css";
import {
  LineChart,
  Line,
  XAxis,
  CartesianGrid,
  Legend,
  Tooltip,
  YAxis,
  ResponsiveContainer,
} from "recharts";

interface MonthTransRentalProps {
  MonthTransRental: { month: string; count: number }[];
}

const MonthTransRental = ({ MonthTransRental }: MonthTransRentalProps) => {
  return (
    <div className="month_rental_trans_container">
      <h2 className="month_rental_trans_title">月ごとのレンタル件数推移</h2>
      <ResponsiveContainer
        height="75%"
        width="90%"
        minHeight={240}
        minWidth={300}>
        <LineChart data={MonthTransRental} className="line_chart">
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="month" />
          <YAxis dataKey="count" />
          <Tooltip />
          <Legend />
          <Line
            type="monotone"
            dataKey="count"
            stroke="#82ca9d"
            name="レンタル件数"
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default MonthTransRental;
